import { action } from 'typesafe-actions';

import { TokenTypes } from './types';

export const setTokenValidated = (validated: boolean) =>
  action(TokenTypes.SET_TOKEN_VALIDATED, validated);
